import React from "react";
import { Switch } from "@mantine/core";
import { QR } from "../theme";

// The prototype's toggle switches (.tgl.on) use the brand accent amber
// (#FFAF4A), not purple — despite this component's name (kept as-is; it
// predates the mockup being checked pixel-for-pixel and renaming it now
// would touch every call site for a cosmetic-only reason). Mantine's
// built-in "violet"/default palette doesn't match that hex either way, so
// it's forced explicitly here.
const PurpleSwitch = (props) => (
  <Switch
    {...props}
    styles={{
      track: {
        // Mantine v6's Switch marks the checked state on the sibling <input>,
        // not a data-checked attribute on the track itself — "&[data-checked]"
        // never matches anything here, which is why this stayed gray instead
        // of turning amber.
        "input:checked + &": {
          backgroundColor: QR.accent,
          borderColor: QR.accent,
        },
      },
    }}
  />
);

export default PurpleSwitch;
